import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getJobItems } from '../../services/api';
import { JobValue } from '../../utils/common';

export const fetchJobValues = createAsyncThunk('lov/fetchJobValues', async () => {
  const data = await getJobItems();
  return data;
});

interface JobState {
  values: JobValue[];
  loading: boolean;
  error: string | null;
}

const initialState: JobState = {
  values: [],
  loading: false,
  error: null,
};

const lovSlice = createSlice({
  name: 'lov',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchJobValues.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchJobValues.fulfilled, (state, action) => {
        state.values = action.payload;
        state.loading = false;
      })
      .addCase(fetchJobValues.rejected, (state) => {
        state.loading = false;
      });
  },
});

export default lovSlice.reducer;